import {useDispatch, useSelector} from "react-redux";
import classNames from "classnames";
import React from "react";
import moment from "moment-timezone";
import _ from "lodash";
import {setSelectedSupportChatSessionId} from "../../../actions";

export default function ChatPreview({supportChatSession, onSelectItem}) {
  const dispatch = useDispatch()
  const account = useSelector(state => state.account)
  const supportChatMessages = useSelector(state => state.supportChatMessages)
  const accountOrganization = useSelector(state => state.accountOrganization)
  const selectedSupportChatSessionId = useSelector((state) => state.selectedSupportChatSessionId)

  const color = accountOrganization?.brand_color_2 || "#FFFFFF";
  const backgroundColor = accountOrganization?.brand_color_1 || "#0ECC46";

  const messages = supportChatMessages.filter(scm => scm.support_chat_session_id === supportChatSession.id)
  const lastMessage = _.orderBy(messages, (support_chat_message) => [moment(support_chat_message.created_at).valueOf()], ['desc'])[0]
  const lastCustomerMessage = _.orderBy(messages.filter(scm => scm.written_by_tag_owner), (support_chat_message) => [moment(support_chat_message.created_at).valueOf()], ['desc'])[0]
  const unreadMessages = messages.filter((supportChatMessage) => !supportChatMessage.read_by_account)

  const style = {}

  const isSessionSelected = supportChatSession.id === selectedSupportChatSessionId
  const isSessionOwner = supportChatSession.assigned_account_id == account.id
  const isNotTaken = !supportChatSession.assigned_account_id
  const isUnanswered = lastMessage?.written_by_tag_owner

  if (isSessionSelected) {
    style.backgroundColor = "rgb(0 123 255 / 14%)"
    style.borderColor = "#007bff"
    style.color = "black"
  } else if (supportChatSession.complete) {
    // Lave it
  } else if (isNotTaken) {
    style.backgroundColor = "rgb(255 193 7 / 18%)"
    style.borderColor = "#ffc107"
    style.color = "#343a40"
  } else if(isUnanswered) {
    style.backgroundColor = "rgb(220 53 69 / 13%)"
    style.borderColor = "#dc3545"
    style.color = "black"
  }

  return <button
    style={style}
    className={classNames("list-group-item list-group-item-action", {
      "active": supportChatSession.id === selectedSupportChatSessionId,
      // "active": supportChatSession.assigned_account_id,
      "completed": supportChatSession.complete
    })}
    onClick={() =>
      dispatch(setSelectedSupportChatSessionId(supportChatSession.id))}
  >
    <div className="d-flex w-100 justify-content-between">
      <h5 className="mb-1">
        {isNotTaken && <i className="fa fa-bell faa-ring animated faa-slow"/>}
        {" "}
        {supportChatSession.tag_owner_name}
      </h5>
      <small>
        Latest Message: {lastMessage ? moment(lastMessage.created_at).locale('en').fromNow() : "-"} {" "}
      </small>
    </div>
    <p className="mb-1">
      {lastMessage?.body}
    </p>
    <small>
      {supportChatSession.complete ? <>This Session is already closed!</> : <>
        {lastCustomerMessage && <div>
          Customer has written
          {unreadMessages.length > 0 && <>
            {" "}<span className={"badge badge-pill badge-primary"}>{unreadMessages.length}</span> new messages,
          </>}
          {" "}{moment(lastCustomerMessage.created_at).locale('en').fromNow()} {" "}
        </div>}
      </>}
      {!isSessionOwner && !isNotTaken && <>
        <br/>
        This chat is handled by: <strong>{supportChatSession.assigned_account_name}</strong>
      </>}
    </small>
  </button>
}